const API_URL = process.env.REACT_APP_API_URL;

export async function fetchSyncOperations({
  page,
  pageCount,
  searchFilters,
}) {
  const body = {
    searchFilters: searchFilters || {},
    sortingCol: ['-syncBatchId'],
    pageCount,
    page,
  };

  const response = await fetch(`${API_URL}sync_operations`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });

  if (!response.ok) throw new Error(`HTTP ${response.status}`);
  return response.json();
}

export async function fetchSyncJobs(syncBatchId) {
  const response = await fetch(
    `${API_URL}sync_jobs?sync_batch_id=${syncBatchId}`
  );
  if (!response.ok) throw new Error(`HTTP ${response.status}`);
  const data = await response.json();
  return data;
}

export async function fetchEntities(zipId) {
  const response = await fetch(`${API_URL}entities?zip_id=${zipId}`);
  if (!response.ok) throw new Error(`HTTP ${response.status}`);
  const data = await response.json();
  return data.entities ?? [];
}

export async function fetchDistinctUsers() {
  const response = await fetch(`${API_URL}distinct_users`);
  if (!response.ok) throw new Error(`HTTP ${response.status}`);
  const data = await response.json();
  return Array.isArray(data) ? data : (data.users ?? data.logins ?? []);
}
